import { Navigate, useSearchParams } from 'react-router-dom';
import { useAppContext } from '@/context/App.context';

export const ProtectedLoggedInRoute: ({ children }: { children: JSX.Element }) => JSX.Element = ({
  children
}) => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl');
  const { isLoggedIn, language } = useAppContext();

  return isLoggedIn ? (
    <Navigate to={`/${language}${redirectUrl || '/dashboard/tests'}`} />
  ) : (
    children
  );
};
